// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3C-AS","buttons":"Footer_buttons__1_DeO"};